import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_EVENT_LIST_ERROR,

    CLEAR_EVENT_LIST,
    CLEAR_EVENT_LIST_FILTER,
    CHANGE_EVENT_LIST_FILTER,
    CHANGE_EVENT_LIST_FILTER_FIELD,

    LOAD_EVENT_LIST_REQUEST,
    LOAD_EVENT_LIST_SUCCESS,
    LOAD_EVENT_LIST_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_EVENT_LIST,
    CLEAR_ERROR: CLEAR_EVENT_LIST_ERROR,
    CLEAR_FILTER: CLEAR_EVENT_LIST_FILTER,
    CHANGE_FILTER: CHANGE_EVENT_LIST_FILTER,
    CHANGE_FILTER_FIELD: CHANGE_EVENT_LIST_FILTER_FIELD,
    LOAD_REQUEST: LOAD_EVENT_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_EVENT_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_EVENT_LIST_FAILURE
}